export default "__VITE_ASSET__08d9a91f__"